import React from 'react'
// components
import BusinessProcessesAPI from 'containers/BusinessProcesses/layers/API/index'
import BusinessProcesses from 'components/PageComponents/Settings/BusinessProcesses/index'

const BusinessProcessesContainer: React.FC = () => {
  return (
    <BusinessProcessesAPI>
      <BusinessProcesses />
    </BusinessProcessesAPI>
  )
}

export default BusinessProcessesContainer
